"use strict";
exports.__esModule = true;
exports.sanitizeFiltersForExport = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var omitBy_1 = tslib_1.__importDefault(require("lodash/omitBy"));
var isUndefined_1 = tslib_1.__importDefault(require("lodash/isUndefined"));
var GdcFilterContext_1 = require("./GdcFilterContext");
var isDateFilter = GdcFilterContext_1.GdcFilterContext.isDateFilter;
var isAttributeFilter = GdcFilterContext_1.GdcFilterContext.isAttributeFilter;
function sanitizeDateFilter(filter) {
    var _a = filter.dateFilter, from = _a.from, to = _a.to, type = _a.type, granularity = _a.granularity, dateFilter = filter.dateFilter;
    var sanitizedProperties = omitBy_1["default"](dateFilter, isUndefined_1["default"]);
    return {
        dateFilter: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ type: type,
            granularity: granularity }, sanitizedProperties), (from === undefined ? {} : { from: String(from) })), (to === undefined ? {} : { to: String(to) }))
    };
}
function sanitizeAttributeFilter(filter) {
    var _a = filter.attributeFilter, displayForm = _a.displayForm, negativeSelection = _a.negativeSelection, attributeElements = _a.attributeElements;
    return {
        attributeFilter: {
            displayForm: displayForm,
            negativeSelection: negativeSelection,
            attributeElements: attributeElements
        }
    };
}
/**
 * @public
 */
function sanitizeFiltersForExport(filters) {
    return filters.map(function (filter) {
        if (isDateFilter(filter)) {
            return sanitizeDateFilter(filter);
        }
        if (isAttributeFilter(filter)) {
            return sanitizeAttributeFilter(filter);
        }
        return filter;
    });
}
exports.sanitizeFiltersForExport = sanitizeFiltersForExport;
//# sourceMappingURL=utils.js.map